module.exports = __webpack_public_path__ + "static/img/news_21.69d184d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_21.jpg
// module id = 6Q1+
// module chunks = 2